import { Box, Paragraph } from '@zillow/constellation-10';

import { PROPERTY_TYPES } from '@zg-rentals/zillow-rental-manager/constants';

const { COMMUNITY, MULTIPLEX } = PROPERTY_TYPES;

type Props = {
  propertyType: string;
  unit: string;
  numUnits: string;
};

const PropertyUnitDisplay = ({ propertyType, unit, numUnits }: Props): JSX.Element | null => {
  const hasUnitOrNumUnits = unit || (numUnits && Number(numUnits) > 0);
  if (!hasUnitOrNumUnits) return null;

  switch (propertyType) {
    case COMMUNITY:
      return (
        <Box css={{ display: 'flex', flexDirection: 'column', gap: '200' }}>
          <Paragraph data-testid="review-number-of-units-label">
            <strong>Number of units</strong>
          </Paragraph>
          <Paragraph data-testid="review-number-of-units-value">{numUnits}</Paragraph>
        </Box>
      );
    case MULTIPLEX:
      return (
        <Box css={{ display: 'flex', flexDirection: 'column', gap: '200' }}>
          <Paragraph data-testid="review-number-of-units-label">
            <strong>Number of units you own or manage</strong>
          </Paragraph>
          <Paragraph data-testid="review-number-of-units-value">{numUnits}</Paragraph>
          <Paragraph textStyle="body-sm" css={{ color: 'text.subtle' }}>
            You can update the number of units next.
          </Paragraph>
        </Box>
      );
    default:
      return (
        <Box css={{ display: 'flex', flexDirection: 'column', gap: '200' }}>
          <Paragraph data-testid="review-unit-number-label">
            <strong>Unit number</strong>
          </Paragraph>
          <Paragraph data-testid="review-unit-number-value">{unit}</Paragraph>
        </Box>
      );
  }
};

export default PropertyUnitDisplay;
